// extracted by mini-css-extract-plugin
export default {"button":"KH34gk4 TYb4J9A"};